"use client";

import { useState } from "react";
import { Button } from "@tremor/react";
import { useAlerts } from "@/entities/alerts/model/useAlerts";
import { ProviderImageUploader } from "./provider-image-uploader";
import { ProviderImagesList } from "./provider-image-list";
import { PageTitle, PageSubtitle } from "@/shared/ui";
import { PhotoIcon } from "@heroicons/react/24/outline";
import { useProviders } from "@/utils/hooks/useProviders";
import { useProviderImages } from "@/entities/provider-images/model/useProviderImages";
export default function ProviderImagesSettings() {
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const {
    useAllAlerts
  } = useAlerts();
  const {
    data: alerts = []
  } = useAllAlerts("feed");
  const {
    data: providers
  } = useProviders();
  const {
    customImages
  } = useProviderImages();

  // Get unique provider names from alerts
  const uniqueProviders = Array.from(new Set(alerts.map(alert => alert.source[0]).filter(provider => !providers?.providers.map(p => p.type).includes(provider))));
  const handleUploadComplete = () => {
    setIsUploadModalOpen(false);
    window.location.reload();
  };
  return <div className="space-y-6" data-sentry-component="ProviderImagesSettings" data-sentry-source-file="provider-images-settings.tsx">
      <div className="flex justify-between items-center">
        <div>
          <PageTitle data-sentry-element="PageTitle" data-sentry-source-file="provider-images-settings.tsx">Provider Icons</PageTitle>
          <PageSubtitle data-sentry-element="PageSubtitle" data-sentry-source-file="provider-images-settings.tsx">Customize provider icons</PageSubtitle>
        </div>
        <Button icon={PhotoIcon} onClick={() => setIsUploadModalOpen(true)} data-sentry-element="Button" data-sentry-source-file="provider-images-settings.tsx">
          Upload New Image
        </Button>
      </div>

      <ProviderImagesList data-sentry-element="ProviderImagesList" data-sentry-source-file="provider-images-settings.tsx" />

      <ProviderImageUploader providers={uniqueProviders} isOpen={isUploadModalOpen} onClose={() => setIsUploadModalOpen(false)} onUploadComplete={handleUploadComplete} customImages={customImages || []} data-sentry-element="ProviderImageUploader" data-sentry-source-file="provider-images-settings.tsx" />
    </div>;
}